import React, {Fragment,  useState, useEffect} from "react";
import { Table, Button } from "react-bootstrap";

import '../../table_report.css';

const TablaRep1_en_proceso = ({datosRP1_en_proceso}) => {
  
  if (datosRP1_en_proceso === null) {
    return(
      <p></p>
    )
  } else if(datosRP1_en_proceso !== null){
    return(
      <Fragment>
        <h4></h4>
        <p className="subtitulos">Proyectos y lotes iniciados</p>
        <div>
          <Table className="tableExp" stripped bordered hover responsive="md" >
            <thead>
              <tr style={{ backgroundColor: "rgb(0,174,195)", color: "white" }}>
                <th></th>
                <th colSpan="2" style={{ textAlign: "center" }}>En Análisis preliminar<br/><span style={{fontSize: '0.8em'}}>(según fecha de carga)</span></th>
                <th colSpan="2" style={{ textAlign: "center" }}>En Proceso<br/><span style={{fontSize: '0.8em'}}>(según fecha de caratulación)</span></th>
              </tr>
              <tr style={{backgroundColor:"rgb(12, 38, 40)", color:"white"}}>
                <th style={{ textAlign: "center" }}>Partido</th>
                <th style={{ textAlign: "center" }}>Cant. de lotes</th>
                <th style={{ textAlign: "center" }}>Cant. de proyectos</th>
                <th style={{ textAlign: "center" }}>Cant. de lotes</th>
                <th style={{ textAlign: "center" }}>Cant. de proyectos</th>
              </tr>
            </thead>
            <tbody>
              {datosRP1_en_proceso.map((item, i) => (
                <tr key={i}>
                  <td>{item.partido_nombre}</td>
                  <td>{item.cant_lotes_analisis_preliminar ?? 0}</td>
                  <td>{item.cant_proyectos_analisis_preliminar ?? 0}</td>
                  <td>{item.cant_lotes_en_proceso ?? 0}</td>
                  <td>{item.cant_proyectos_en_proceso ?? 0}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Fragment>
    )
  }
};


export default TablaRep1_en_proceso;
